import { ellipsis } from 'polished';
import styled from 'styled-components';
import Icon from '../../../CommonComponents/Icon';

export const Name = styled.div`
  font-size: 24px;
  font-weight: 600;
  line-height: 1.3em;
  margin-top: -0.15em;
  ${ellipsis()}
`;

export const OnlineIcon = styled(Icon).attrs({
  className: 'fas fa-circle',
})`
  vertical-align: middle;
  font-size: 8px;
  color: ${props => (props.online ? '#39AC67' : '#ddd')};
  margin-right: 8px;
`;

export const ClientOnlineStatus = styled.div`
  display: block;
  font-size: 14px;
`;
